import { useState } from 'react';
import Basic from './Basic';
import LandingPage from './LandingPage';
import MyTabs from '../../../components/MyTabs';

const General = () => {
    const [tabValue, setTabValue] = useState(0);

    const tabs = [
        { id: "basic", title: "Basic", Component: Basic },
        { id: "landing-page", title: "Landing page" ,tabValue:{tabValue},setTabValue:{setTabValue}, Component: LandingPage},
      ];

    return (
        <>
            <MyTabs list={tabs}/>
        </>
    )
};

export default General;